import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const RedemptionQueueTable = ({ redemptions, onAction }) => {
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const filteredRedemptions = redemptions?.filter(r => {
    const matchesFilter = filter === 'all' || r?.status === filter;
    const matchesSearch = !searchTerm || 
      r?.userName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
      r?.userEmail?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
      r?.rewardTitle?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    return matchesFilter && matchesSearch;
  }) || [];

  const getStatusBadge = (status) => {
    const styles = {
      pending: 'bg-warning/10 text-warning',
      completed: 'bg-success/10 text-success',
      failed: 'bg-error/10 text-error',
      cancelled: 'bg-muted text-muted-foreground'
    };
    return styles?.[status] || styles?.pending;
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-2">
      <div className="p-24 border-b border-border">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-16 md:space-y-0">
          <h3 className="text-xl font-heading font-semibold text-secondary">
            Redemption Queue
          </h3>
          <div className="flex flex-col sm:flex-row space-y-12 sm:space-y-0 sm:space-x-12">
            <div className="relative">
              <Icon name="Search" size={18} className="absolute left-12 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <input
                type="text"
                placeholder="Search redemptions..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e?.target?.value)}
                className="pl-40 pr-16 py-10 border border-border rounded-lg bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 w-full sm:w-[250px]"
              />
            </div>
            <select
              value={filter}
              onChange={(e) => setFilter(e?.target?.value)}
              className="px-16 py-10 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
            >
              <option value="all">All Status</option>
              <option value="pending">Pending</option>
              <option value="completed">Completed</option>
              <option value="failed">Failed</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-24 py-16 text-left text-sm font-semibold text-secondary">User</th>
              <th className="px-24 py-16 text-left text-sm font-semibold text-secondary">Reward</th>
              <th className="px-24 py-16 text-left text-sm font-semibold text-secondary">Points</th>
              <th className="px-24 py-16 text-left text-sm font-semibold text-secondary">Status</th>
              <th className="px-24 py-16 text-left text-sm font-semibold text-secondary">Date</th>
              <th className="px-24 py-16 text-left text-sm font-semibold text-secondary">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {filteredRedemptions?.length === 0 ? (
              <tr>
                <td colSpan="6" className="px-24 py-32 text-center text-muted-foreground">
                  No redemptions found
                </td>
              </tr>
            ) : (
              filteredRedemptions?.map((redemption) => (
                <tr key={redemption?.id} className="hover:bg-muted/30 transition-smooth">
                  <td className="px-24 py-16">
                    <div>
                      <p className="font-medium text-foreground">{redemption?.userName}</p>
                      <p className="text-sm text-muted-foreground">{redemption?.userEmail}</p>
                    </div>
                  </td>
                  <td className="px-24 py-16">
                    <p className="text-foreground">{redemption?.rewardTitle}</p>
                    <p className="text-xs text-muted-foreground">{redemption?.benefitType}</p>
                  </td>
                  <td className="px-24 py-16">
                    <span className="font-semibold text-primary">{redemption?.pointsSpent}</span>
                  </td>
                  <td className="px-24 py-16">
                    <span className={`px-12 py-4 rounded-full text-xs font-medium ${getStatusBadge(redemption?.status)}`}>
                      {redemption?.status}
                    </span>
                  </td>
                  <td className="px-24 py-16 text-sm text-muted-foreground">
                    {new Date(redemption?.redeemedAt)?.toLocaleDateString()}
                  </td>
                  <td className="px-24 py-16">
                    {redemption?.status === 'pending' && (
                      <div className="flex space-x-8">
                        <button
                          onClick={() => onAction(redemption?.id, 'completed', 'Approved by admin')}
                          className="p-8 bg-success/10 text-success rounded-lg hover:bg-success/20 transition-smooth"
                          title="Approve"
                        >
                          <Icon name="Check" size={16} />
                        </button>
                        <button
                          onClick={() => onAction(redemption?.id, 'failed', 'Rejected by admin')}
                          className="p-8 bg-error/10 text-error rounded-lg hover:bg-error/20 transition-smooth"
                          title="Reject"
                        >
                          <Icon name="X" size={16} />
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RedemptionQueueTable;